module.exports = __webpack_public_path__ + "85592fa2f40ec66d7b28575bbabdf6d4.png";